export interface AssetInfo {
  id?: number;
  name?: string;
  identifier?: string;
  spaceName?: string;
  level?: string;
  description?: string;
  category?: string;
  subCategory?: string;
  typeName?: string;
  elementFamily?: string;
  typeWorkset?: string;
  externalIdentifier?: string;
  manufacturer?: string;
  model?: string;
  cost?: number;
  installationDate?: string;
  plans?: number;
  critical?: string;
  department?: string;
  isBms?: boolean;
  bmsCategory?: string;
  urn?: string;
  objectId?: number;
}

export interface AssetAmc {
  startDate?: string;
  endDate?: string;
  amcType?: string;
  amcDescription?: string;
  vendorName?: string;
  vendorEmail?: string;
  vendorContact?: string;
  description?: string;
}

export interface DocumentDto {
  documentId: number;
  name?: string;
  type?: string;
  url?: string;
  description?: string;
}

export interface AssetDetails extends AssetInfo {
  amcDetails?: AssetAmc[];
  documents?: DocumentDto[];
}

export interface AssetDepartmentCount {
  electrical: number;
  fireProtection: number;
  mechanical: number;
  phe: number;
}

export interface Occupancy {
  vendorName: string;
  category: string;
  area: number;
  isOccupied: boolean;
}
